// updates the existing wrapper component to work with v6 react router
// essentially a copy paste of ShipiumAdminRoute
// the only real change is that that wrapped component does not include another <Route/>
import React, { useEffect } from 'react';
import { useStoreState, useStoreActions } from '../../store';
import { Redirect } from 'react-router-dom';
import type { LayoutType } from '../LayoutWrapper';
import { LayoutWrapper } from '../LayoutWrapper';
import { CompatRoute } from 'react-router-dom-v5-compat';
import { useSession } from '~/hooks/useSession';

export interface V6ShipiumAdminRouteProps {
  layoutType?: LayoutType;
  path: string;
  children: React.ReactNode;
  flexibleWidth?: boolean;
}

export const V6ShipiumAdminRoute = ({
  path,
  layoutType = 'BaseLayout',
  children,
  flexibleWidth = false,
}: V6ShipiumAdminRouteProps) => {
  // this is data fetching is copied from V6OptionProtectedRoute.tsx
  const activePartner = useStoreState((state) => state?.partner?.activePartner);
  const fetchPartner = useStoreActions((actions) => actions.partner.fetchPartner);
  const sessionPartnerId = useStoreState((state) => state.session.user?.sessionPartnerId);

  useEffect(() => {
    if (!activePartner && sessionPartnerId) {
      fetchPartner(sessionPartnerId);
    }
  }, [sessionPartnerId, fetchPartner, activePartner]);

  const { isShipiumView } = useSession();
  const throwAppError = useStoreActions((actions) => actions.errors.throwApplicationError);
  if (!isShipiumView) {
    throwAppError({
      error: new Error(`Access to "${path}" denied`),
      message: `Access to "${path}" denied`,
    });
  }
  return (
    <CompatRoute
      path={path}
      render={() => (
        <LayoutWrapper layoutType={layoutType} flexibleWidth={flexibleWidth}>
          {isShipiumView ? children : <Redirect to="/access-denied" />}
        </LayoutWrapper>
      )}
    ></CompatRoute>
  );
};
